import { combineReducers } from 'redux';
import vehicleStatus from './vehicle-status';
export { vehicleStatus };
export default combineReducers({
    vehicleStatus,
});
